import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { slotLabel } from "@/components/SlotPicker";

// PB3: polls /consult/alerts every 30 s. RMs: "New consultation booked · Take this one". Pre-Sales: 1-hour confirmation nudge.
export function ConsultPopup({ user }) {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [d, setD] = useState(null);
  const roles = user?.roles || [];
  const on = roles.some((r) => ["RM", "Manager", "Admin", "Presales Caller", "Presales Manager"].includes(r));
  useEffect(() => {
    if (!on) return undefined;
    const poll = () => api.get("/consult/alerts").then((r) => setD(r.data)).catch(() => {});
    poll(); const t = setInterval(poll, 30000);
    return () => clearInterval(t);
  }, [on, pathname]);
  if (!on || !d || (!d.bookings.length && !d.nudges.length)) return null;
  const take = async (b) => {
    try { await api.post(`/consult/events/${b.event_id}/claim`); toast.success(`${b.client} is yours`); setD((x) => ({ ...x, bookings: x.bookings.filter((o) => o.event_id !== b.event_id) })); navigate("/consultations"); }
    catch (e) { toast.error(e?.response?.data?.detail || "Failed"); setD((x) => ({ ...x, bookings: x.bookings.filter((o) => o.event_id !== b.event_id) })); }
  };
  const dismiss = async (b) => { setD((x) => ({ ...x, bookings: x.bookings.filter((o) => o.event_id !== b.event_id) })); api.post(`/consult/alerts/${b.event_id}/dismiss`).catch(() => {}); };
  return (
    <div className="fixed bottom-4 left-4 z-[60] w-[340px] max-w-[95vw] space-y-2" data-testid="consult-popup">
      {d.nudges.map((n) => (
        <div key={n.event_id} className="rounded-2xl bg-white shadow-2xl border-2 border-[#CA1212] p-3" data-testid={`consult-nudge-${n.case_id}`}>
          <div className="text-[11px] uppercase tracking-wide text-[#CA1212] font-semibold">Starts in {n.minutes_to_start} min · not confirmed</div>
          <div className="text-sm font-semibold text-[#333333] mt-1">{n.client} <span className="font-mono text-xs text-[#6B7280]">{n.case_id}</span></div>
          <button onClick={() => navigate("/presales/my-calls")} data-testid="consult-nudge-go" className="mt-2 w-full py-2 rounded-xl bg-[#CA1212] text-white text-sm font-medium">Confirm now</button>
        </div>))}
      {d.bookings.map((b) => (
        <div key={b.event_id} className="rounded-2xl bg-white shadow-2xl border-2 border-[#FF4802] p-4" data-testid={`consult-booked-${b.case_id}`}>
          <div className="flex justify-between"><div className="text-[11px] uppercase tracking-wide text-[#FF4802] font-semibold">New consultation booked</div><button onClick={() => dismiss(b)} className="text-xs text-[#6B7280]" data-testid="consult-booked-dismiss">later</button></div>
          <div className="text-lg font-semibold text-[#333333] mt-1">{b.client} <span className="font-mono text-xs text-[#6B7280]">{b.case_id}</span></div>
          <div className="text-sm text-[#333333]">{slotLabel(b.start)}</div>
          <div className="text-xs text-[#6B7280]">booked by {b.by_name}{b.guest_email ? "" : " · no e-mail, link on WhatsApp"}</div>
          <button onClick={() => take(b)} data-testid="consult-booked-take" className="mt-3 w-full py-3 rounded-xl bg-[#FF4802] text-white text-base font-semibold hover:bg-[#E2521B]">Take this one</button>
        </div>))}
    </div>
  );
}
